import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Crown, Loader2 } from "lucide-react";
import { fullDate } from "@/lib/format";

export default function PremiumStatus({ premium, onCancel, onResume }) {
  const [busy, setBusy] = useState(false);
  const act = async (fn) => { setBusy(true); await fn(); setBusy(false); };
  const ending = premium.cancel_at_period_end;

  return (
    <div className="mm-glow-card p-6 sm:p-8 border-[#00C896]/30" data-testid="premium-status">
      <div className="flex flex-wrap items-start justify-between gap-4">
        <div className="flex items-center gap-3">
          <span className="h-12 w-12 rounded-2xl bg-[#00C896]/15 flex items-center justify-center text-[#00C896]"><Crown className="h-6 w-6" /></span>
          <div>
            <p className="font-display text-xl font-semibold">You're on Premium</p>
            <p data-testid="premium-plan-label" className="text-sm text-slate-400">{premium.plan === "yearly" ? "Yearly · £79.99 / year" : "Monthly · £7.99 / month"}</p>
          </div>
        </div>
        <span data-testid="premium-status-pill" className={`text-xs px-2.5 py-1 rounded-full border ${ending ? "border-amber-500/30 bg-amber-500/10 text-amber-300" : "border-[#00C896]/30 bg-[#00C896]/10 text-[#00C896]"}`}>
          {ending ? "Cancels at period end" : "Active"}
        </span>
      </div>
      <p data-testid="premium-renewal" className="mt-5 text-sm text-slate-300">
        {ending ? "Premium ends on " : "Next renewal on "}<span className="font-semibold text-white">{fullDate(premium.current_period_end)}</span>
      </p>
      <div className="mt-5">
        {ending ? (
          <Button data-testid="premium-resume-button" disabled={busy} onClick={() => act(onResume)} className="rounded-full bg-[#00C896] hover:bg-[#00E5AC] text-[#04140D] font-semibold">
            {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : "Keep Premium"}
          </Button>
        ) : (
          <Button data-testid="premium-cancel-button" disabled={busy} onClick={() => act(onCancel)} variant="outline" className="rounded-full border-white/15 bg-transparent text-slate-300 hover:bg-white/5 hover:text-white">
            {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : "Cancel subscription"}
          </Button>
        )}
      </div>
    </div>
  );
}
